import React, { useState, useEffect } from "react";
import { Switch, Input, Select, Typography, Card, Button, message } from "antd";
import api from "../../api";

const { TextArea } = Input;
const { Option } = Select;
const { Title } = Typography;

const CommentSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await api.get("/panel/setting/comment", {
        params: { per_page: 10, page: 1 },
      });
      setSettings(response.data.data);
    } catch (error) {
      message.error("خطا در دریافت تنظیمات دیدگاه");
    } finally {
      setLoading(false);
    }
  };

  const handleSwitchChange = (key) => (value) => {
    setSettings({ ...settings, [key]: value ? "1" : "0" });
  };

  const handleInputChange = (key) => (e) => {
    setSettings({ ...settings, [key]: e.target.value });
  };

  const handleSelectChange = (value) => {
    setSettings({ ...settings, showUser: value });
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    Object.entries(settings).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      await api.post("/panel/setting/storeComment", formData);
      message.success("تنظیمات با موفقیت ذخیره شد");
    } catch (error) {
      message.error("خطا در ذخیره تنظیمات دیدگاه");
    }
  };

  return (
    <Card loading={loading}>
      <h1 className="text-xl">تنظیمات دیدگاه</h1>
      <div className="flex flex-col md:flex-row gap-4 p-4">
        <div className="w-full md:w-2/3 bg-white p-4 rounded-lg shadow">
          <Title level={5}>کلماتی که ممنوع هستند (با , جدا کنید)</Title>
          <TextArea
            rows={4}
            value={settings?.forbiddens || ""}
            onChange={handleInputChange("forbiddens")}
            placeholder="مثلاً: خراب،دیوانه"
            className="mb-4"
          />

          <Title level={5}>نمایش کاربر</Title>
          <Select
            value={settings.showUser || "0"}
            onChange={handleSelectChange}
            className="w-full"
          >
            <Option value="0">نمایش کاربر همراه فقط نام</Option>
            <Option value="1">نمایش نام و آواتار کاربر</Option>
            <Option value="2">نمایش به صورت ناشناس</Option>
          </Select>
        </div>

        <div className="w-full md:w-1/3 bg-gray-50 p-4 rounded-lg shadow">
          {[
            { label: "نیاز به تایید دیدگاه", key: "approved" },
            { label: "فعال کردن دکمه پاسخ به دیدگاه", key: "reply" },
            { label: "اجبار به نوشتن ایمیل و نام", key: "coercion" },
            { label: "نمایش دیدگاه فقط برای کاربران سایت", key: "checkUser" },
            { label: "نمایش زمان آنلاین بودن کاربر", key: "checkOnline" },
          ].map(({ label, key }) => (
            <div key={key} className="flex items-center justify-between mb-2">
              <span>{label}</span>
              <Switch
                checked={settings[key] ==="1"}
                onChange={handleSwitchChange(key)}
              />
            </div>
          ))}

          <div className="flex items-center justify-between mb-2">
            <span>محدودسازی دیدگاه گذاشتن</span>
            <Input
              type="number"
              min={1}
              value={settings.limited || 10}
              onChange={handleInputChange("limited")}
              className="w-20"
            />
          </div>

          <div className="flex items-center justify-between">
            <span>تعداد نمایش دیدگاه‌ها در هر صفحه</span>
            <Input
              type="number"
              min={1}
              value={settings.pages || 10}
              onChange={handleInputChange("pages")}
              className="w-20"
            />
          </div>
        </div>
      </div>

      <Button type="primary" onClick={handleSubmit} className="mt-4">
        ذخیره تنظیمات
      </Button>
    </Card>
  );
};

export default CommentSettings;
